import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { TAGS_ACTION_TYPE } from '../actions';

const initialState = {};

const tagsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case TAGS_ACTION_TYPE.GET_TAGS:
        return payload || state;

      case TAGS_ACTION_TYPE.CREATE_TAG:
      case TAGS_ACTION_TYPE.EDIT_TAG:
        draft[payload.tagId] = payload;
        break;

      case TAGS_ACTION_TYPE.DELETE_TAG:
        draft[meta.tagId].isDeleted = true;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default tagsReducer;
